// extracted by mini-css-extract-plugin
export default {"info":"TbGC0_","infoContent":"EZe91p","actions":"hcVrnM","actionItem":"TYTsEZ","boardInfo":"cPAcJW"};